import script from "./DashboardAssistantVQ.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardAssistantVQ.vue?vue&type=script&setup=true&lang=js"

import "./DashboardAssistantVQ.vue?vue&type=style&index=0&id=30cb144c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30cb144c"]])

export default __exports__